import { Recipe } from '@library/menu-service'

const ImageTypes = {
  HomepageImage: 'homepage-image',
  MoodImage: 'mood-image',
}

export const findImageUrls = (recipeImages: Recipe['images'], useHomepageImage = false) => {
  const homepageImage = recipeImages.find((image) => image.type === ImageTypes.HomepageImage)

  if (useHomepageImage && homepageImage !== undefined) {
    const homepageImageUrls = homepageImage.crops || []

    if (homepageImageUrls.length > 0) {
      return homepageImageUrls
    }
  }

  const firstImageUrls = recipeImages[0]?.crops || []
  const moodImage = recipeImages.find((image) => image.type === ImageTypes.MoodImage)

  return moodImage ? moodImage.crops : firstImageUrls
}
